import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { Form, Input, Button, Row, Col, Divider } from 'antd';
import { ReactComponent as PasswordHide } from '@/views/account/assets/icons/password-hidden.svg';
import { ReactComponent as PasswordShow } from '@/views/account/assets/icons/password-show.svg';
import Validator from '../../../../../views/account/utils/formValidator';
import {
  GASignUpClickToLogin,
  GASignUpClickToPrivacy,
  GASignUpClickToService,
  GASignUpClickConfirm,
} from '@/views/account/ga/signUp';
import { ReactComponent as GoogleIcon } from '@/views/account/assets/icons/google.svg';
import { getGoogleUrl,requsetGetCode } from '@/views/account/api/apis';
import '@/views/account/assets/signUp.scss';
import sentGAEvent from '@/views/account/ga';
import Utils from '@/utils/utils';
import HitPawLogo from '@/views/account/assets/images/hitpaw-logo.png';
import './signUp.less';
const SignUpRender = ({
  captchaObj,
  submitLoading,
  urlSearch,
  handleRequestSignUp,

}) => {
  const { t } = useTranslation(['loginAndSignUp', 'common']);
  console.log('tttttttttttttt', urlSearch);
  const [googleLoading, setGoogleLoading] = useState(false);
  const [showGoogle, setShowGoogle] = useState(true);
  const [codeToken,setCodeToken] = useState('')
  const [seconds, setSeconds] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (formValue) => {
    let registerValue = {
      ...formValue,
      codeToken:codeToken
    }
    handleRequestSignUp(registerValue)
  }

  useEffect(() => {//倒计时定时
    let timer;
    if (isCounting && seconds > 0) {
      timer = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds - 1);
      }, 1000);
    }else{
      setIsCounting(false);
      setSeconds(60)
    }
    return () => clearInterval(timer);
  }, [isCounting, seconds]);

  const loginByGoogle = () => {
    sentGAEvent({
      category: 'sign_up',
      action: 'GoogleSignUp_Click',
    });
    const urlParams = new URLSearchParams(urlSearch);
    const sliceIndex = window.location.href.lastIndexOf('#') + 1;
    let personalUrl;
    const localUrl = urlParams.get('redirect');
    const to = urlParams.get('to');
    console.log('localUrl', localUrl);
    // 这里用于兼容不是从功能页跳转登录的情况，即从购买页登录，没有redirect，只有to
    // 如果没有redirect，有to，说明是购买跳的登录，登录完重回购买
    if (!localUrl && to) {
      personalUrl = window.location.href.substring(0, sliceIndex) + '/purchase';
      localStorage.setItem('redirect', personalUrl);
    } else {
      // personalUrl =
      //   window.location.href.substring(0, sliceIndex) +
      //   '/personal-center/profile';
      if (localUrl) {
        localStorage.setItem('redirect', localUrl);
      }
    }
    // localStorage.setItem('localUrl', localUrl); //重定向地址
    // localStorage.setItem('personalUrl', personalUrl); //个人中心地址
    let url = window.location.href.split('?')[0];
    window.location.href = url;
    setGoogleLoading(true);
    getGoogleUrl(window.location.href)
      .then((res) => {
        setGoogleLoading(false);
        console.log('res', res);
        if (res.code === 200) {
          window.location.href = res.data.redirect;
        }
      })
      .catch((err) => {
        setGoogleLoading(false);
      });
  };
  const linkToOnline = () => {
    window.location.href = 'https://online.hitpaw.com/';
  };

  const handleRequsetGetCode = async() => {
   console.log("dskfjsl", form.getFieldValue('email'))
   let email =  form.getFieldValue('email') 
   
    setIsCounting(true)
    let formData = new FormData();
    formData.append('email', email.replace(/(^\s*)|(\s*$)/g, ''));
    
    requsetGetCode({
      body: formData,
    })
      .then((res) => {
        if (res.code === 200) {
          setCodeToken(res.data.token)
          // message.success(i18n.t('loginAndSignUp:getCodeSuccessTips'));
        } else {
          setIsCounting(false)
        }
      })
      .catch((err) => {
        console.log(err);

        setIsCounting(false)
      });
  };
  /**
   * 自定义密码显示和隐藏icon
   * @param {*} visible
   */
  const passWordIconRender = (visible) =>
    visible ? <PasswordShow /> : <PasswordHide />;

 

  const handleOnEmailChange = (e) => {
    /**
     * 监听email值发生变化时，去执行以下confirm email
     */
    let confirmEmailValue = form.getFieldValue('comfirmEmail');
    if (confirmEmailValue) {
      form.validateFields(['comfirmEmail']);
    }
  };

  // 是否展示google登录
  const isShowGoogle = () => {
    let nonGoogle = ['kr', 'ar', 'nl', 'tr', 'tw']; // 因google重定向地址配置问题，暂不展示第三方登录
    const curLang = Utils.getLanguage();
    const showGoogle = !nonGoogle.includes(curLang);
    setShowGoogle(showGoogle);
  };

  // 进入登录页面的时候检查链接是否有带urlSearch
  // 1、带了 urlSearch，说明是从其他站点的功能页面跳转过来登录，走正常逻辑
  // 2、没带 urlSearch，则是从购买页进入，点击购买按钮才跳的登录，这时候重新获取urlSearch
  const redirectToPurchase = () => {
    let href = window.location.href;
    if (urlSearch === '') {
      urlSearch =
        href.indexOf('?') !== -1 ? href.substring(href.indexOf('?')) : '';
    }
  };

  redirectToPurchase();

  useEffect(() => {
    isShowGoogle();
  }, []);

  return (
    <div className='SignUpContent'>
      <div className='leftImg' />
      <div className='rightForm'>
        <div className='topContainer'>
          <img
            className='hitPawLogo'
            onClick={() => linkToOnline()}
            src={HitPawLogo}
            alt=''
          />
          <div className='signUpText'>
            {t('upgradePersonal:signUpYourAccount')}
          </div>
        </div>
        <div className='SignUpForm'>
          <Form
            form={form}
            name='signUp'
            className='w-100'
            onFinish={onFinish}
            validateTrigger='onBlur'
          >
            <Form.Item
              name='email'
              label=''
              rules={[
                {
                  required: true,
                  formName: 'signUp',
                  validator: Validator.emailValidator,
                },
              ]}
            >
              <Input
                placeholder={t('common:email')}
                onChange={handleOnEmailChange}
                autoComplete='off'
                allowClear
              />
            </Form.Item>
            <Form.Item
              name='comfirmEmail'
              label=''
              rules={[
                {
                  required: true,
                  formName: 'signUp',
                  validator: async (rule, value) =>
                    Validator.emailSameValidator(
                      rule,
                      value,
                      form.getFieldValue('email')
                    ),
                },
              ]}
            >
              <Input
                placeholder={t('common:confirmEmail')}
                autoComplete='off'
                allowClear
              />
            </Form.Item>
            <Form.Item
              name='password'
              label=''
              rules={[
                {
                  required: true,
                  formName: 'signUp',
                  validator: Validator.passwordValidator,
                },
              ]}
            >
              <Input.Password
                placeholder={t('common:password')}
                iconRender={passWordIconRender}
                autoComplete='off'
                allowClear
              />
            </Form.Item>
            <Form.Item
              name='verification'
              label=''
              rules={[
                {
                  required: true,
                  formName: 'signUp',
                  validator: Validator.emptyValidator,
                },
              ]}
            >
              <Row gutter={8}>
                <Col span={16}>
                  <Input
                    style={{ height: 48 }}
                    placeholder={t('common:verificationCode')}
                  />
                </Col>
                <Col span={8}>
                  <Button
                  type='primary'
                    className='w-100 d-block'
                    style={{ height: 48, borderRadius: 4, cursor: 'pointer' }}
                    onClick={handleRequsetGetCode}
                  >
                     {!isCounting?'get code':seconds}
                  </Button>
                </Col>
              </Row>
            </Form.Item>

            <Form.Item>
              <Button
                className='w-100 fw-bolder SignUpBtn'
                type='primary'
                htmlType='submit'
                size='large'
                loading={submitLoading}
                onClick={GASignUpClickConfirm}
              >
                {t('common:signUp')}
              </Button>
            </Form.Item>
          </Form>
          <p className='mb-2 pb-4 text-center'>
            <Trans i18nKey='loginAndSignUp:loginTips'>
              Text
              <Link
                className='ms-2'
                to={`/login${urlSearch}`}
                onClick={GASignUpClickToLogin}
              >
                Link
              </Link>
            </Trans>
          </p>
          <Divider
            style={{
              marginTop: 0,
            }}
            plain
          >
            Or
          </Divider>
          <Button
            onClick={() => loginByGoogle()}
            className='w-100 fw-bolder'
            icon={<GoogleIcon style={{ marginRight: 5 }} />}
            type='default'
            loading={googleLoading}
            size='large'
            style={{
              marginBottom: 16,
              height: 56,
              borderRadius: 100,
            }}
          >
            {t('ContinuewithGoogle')}
          </Button>
          <p className='privacy' style={{ textAlign: 'center' }}>
            <Trans i18nKey='loginAndSignUp:signUpPrivacyTips'>
              Text
              <Link
                className='text-primary'
                to='/services-policy'
                onClick={GASignUpClickToService}
                target='_blank'
              >
                Link
              </Link>
              Text
              <Link
                className='text-primary'
                to='/privacy-policy'
                onClick={GASignUpClickToPrivacy}
                target='_blank'
              >
                Link
              </Link>
            </Trans>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUpRender;
